// extracted by mini-css-extract-plugin
export default {"breadcrumb":"co-z","breadcrumbItem":"do-z","hideOnMobile":"eo-z"};